import { useState, useEffect, memo, useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { getReseFileuploadLogsInit } from "./redux/actions";
import ReseFileuploadService from "./ReseFileuploadService";
import { parseDateTime } from "../../../common/date-time";

const service = new ReseFileuploadService();

const ReseFileuploadLogs = () => {
    const uploadLogs = useSelector(
        (state) => state.fileUpload.fileUploadLogs
    );
    const dispatch = useDispatch();
    const [tableFilters, setTableFilters] = useState(null);
    const logsTableRef = useRef(null);


    useEffect(() => {
        fetchUploadLogs();
        initializeTableFilter();
    }, []);

    const fetchUploadLogs = () => {
        dispatch(getReseFileuploadLogsInit());
    };

    const initializeTableFilter = () => {
        setTableFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            fileType: {
                operator: FilterOperator.AND,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.CONTAINS },
                ],
            },
            fileName: {
                operator: FilterOperator.AND,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.CONTAINS },
                ],
            },
            storeId: {
                operator: FilterOperator.AND,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.CONTAINS },
                ],
            },
            createdByUserId: {
                operator: FilterOperator.AND,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.CONTAINS },
                ],
            },
            status: {
                operator: FilterOperator.AND,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.CONTAINS },
                ],
            },
            snowTicketNumber: {
                operator: FilterOperator.AND,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.CONTAINS },
                ],
            },
            versionId: {
                operator: FilterOperator.AND,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.CONTAINS },
                ],
            },
        });
    };

    const statusTemplate = ({ status }) => {
        if (status){
            let color = "";
        if (["Failed", "Rejected"].includes(status)) {
            color = "#c63737";
        } else if (["Processed"].includes(status)) {
            color = "#198901";
        } else if (["Uploaded", "Processing"].includes(status)) {
            color = "#1b6dd3";
        } else {
            color = "#91720e";
        }
        return <strong style={{ color }}>{status.toUpperCase()}</strong>;
        }
        else{
            return <div style={{textAlign: "center"}}>-</div>
        }
        
    };

    const uploadedAtTemplate = ({ createdDateTime }) =>
        !!createdDateTime ? parseDateTime(createdDateTime) : "-";

       /**
   * Function to export table data
   */
    const exportuploadLogs = () => logsTableRef.current.exportCSV();

    return (
        <div className="file-upload-log-container">
            <div className="d-flex justify-content-between">
            <strong>File Upload Logs</strong>
            <span className="d-flex">
            <Button
                icon="pi pi-refresh"
                className="p-button-text"
                onClick={fetchUploadLogs}
            />
            <Button 
                icon="pi pi-download"
                className="p-button-text"
                onClick={exportuploadLogs}
                style={{float: "right"}}
            />
            </span>
            </div>
            <DataTable
                value={uploadLogs}
                ref={logsTableRef}
                filters={tableFilters}
                filterDisplay="menu"
                sortField="createdDateTime"
                sortOrder={-1}
                paginator
                paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink "
                currentPageReportTemplate="Items per page"
                rows={10}
                rowsPerPageOptions={[10, 20, 50]}
                emptyMessage="No logs found."
            >
                <Column
                    header="File Type"
                    field="fileType"
                    sortable
                    filter
                />
                <Column
                    header="File Name"
                    field="fileName"
                    sortable
                    filter
                />
                <Column
                    header="Store"
                    field="storeId"
                    sortable
                    filter
                />
                <Column
                    header="Status"
                    field="status"
                    body={statusTemplate}
                    sortable
                    filter
                />
                <Column
                    header="Created"
                    field="createdDateTime"
                    body={uploadedAtTemplate}
                    sortable
                />
                <Column
                    header="Created By"
                    field="createdByUserId"
                    sortable
                    filter
                />
                <Column
                    header="Version Id"
                    field="versionId"
                    sortable
                    filter
                />
                <Column
                    header="Ticket"
                    field="snowTicketNumber"
                    sortable
                    filter
                />
                <Column
                    header="Error Message"
                    field="errorMessage"
                />
            </DataTable>
        </div>
    );
};

export default memo(ReseFileuploadLogs);
